var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.208,
    height: 47.209,
    viewBox: "0 0 47.208 47.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3430",
    "data-name": "Grupo 3430",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10981",
    "data-name": "Caminho 10981",
    d: "M38.838,25.278h.533a8.137,8.137,0,0,0,4.921-1.656A21.146,21.146,0,1,1,30.7,10.032a8.141,8.141,0,0,0-1.656,4.921v.534a15.454,15.454,0,1,0,9.792,9.792Zm-3.232.625a12.2,12.2,0,1,1-7.185-7.185L22.4,24.743a5.7,5.7,0,1,0,7.182,7.188Z",
    transform: "translate(0 -1.117)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10982",
    "data-name": "Caminho 10982",
    d: "M36.767,18.6V14.116a4.885,4.885,0,0,1,1.43-3.454l7.186-7.185a1.628,1.628,0,0,1,2.779,1.151V7.883A1.627,1.627,0,0,0,49.79,9.511h3.256A1.628,1.628,0,0,1,54.2,12.29l-7.185,7.186a4.885,4.885,0,0,1-3.454,1.43H39.069l-9.29,9.29a1.628,1.628,0,0,1-2.3-2.3Z",
    transform: "translate(-4.466 0)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.966447aa82440355fdc6d96f72e01405.svg";
export { ForwardRef as ReactComponent };